import * as React from 'react';
import { IgcInputComponent as Component } from 'igniteui-webcomponents';
import type { IgcInputComponentEventMap } from 'igniteui-webcomponents';
import { type EventName, createComponent } from '../react-props.js';

/**
 * @slot prefix - Renders content before the input.
 * @slot suffix - Renders content after input.
 * @slot helper-text - Renders content below the input.
 * @slot value-missing - Renders content when the required validation fails.
 * @slot type-mismatch - Renders content when the a type url/email input pattern validation fails.
 * @slot pattern-mismatch - Renders content when the pattern validation fails.
 * @slot too-long - Renders content when the maxlength validation fails.
 * @slot too-short - Renders content when the minlength validation fails.
 * @slot range-overflow - Renders content when the max validation fails.
 * @slot range-underflow - Renders content when the min validation fails.
 * @slot step-mismatch - Renders content when the step validation fails.
 * @slot custom-error - Renders content when setCustomValidity(message) is set.
 * @slot invalid - Renders content when the component is in invalid state (validity.valid = false).
 * @fires igcInput - Emitted when the control input receives user input.
 * @fires igcChange - Emitted when the control's checked state changes.
 * @csspart container - The main wrapper that holds all main input elements.
 * @csspart input - The native input element.
 * @csspart label - The native label element.
 * @csspart prefix - The prefix wrapper.
 * @csspart suffix - The suffix wrapper.
 * @csspart helper-text - The helper text wrapper.
 * @class
 */
export const IgrInput = /* @__PURE__ */ createComponent({
  tagName: 'igc-input',
  displayName: 'IgrInput',
  elementClass: Component,
  react: React,
  events: {
    onInput: 'igcInput' as EventName<IgcInputComponentEventMap['igcInput']>,
    onChange: 'igcChange' as EventName<IgcInputComponentEventMap['igcChange']>,
  },
});

export type IgrInput = Component;

/** @deprecated Module register is no longer needed and can be removed */
export const IgrInputModule = Component;
